import { Controller } from "@hotwired/stimulus";

export default class FileToggleController extends Controller {
  static targets = ["checkbox", "iconsWrapper", "disabledIcon", "enabledIcon"];
  static classes = ["enabled", "disabled"];

  connect() {
    this.update()
  }

  enable() {
    this.element.classList.remove(...this.disabledClasses)
    this.element.classList.add(...this.enabledClasses)

    this.iconsWrapperTarget.classList.remove('translate-x-0')
    this.iconsWrapperTarget.classList.add('translate-x-5')

    this.disabledIconTarget.classList.remove('opacity-100','ease-in','duration-200')
    this.disabledIconTarget.classList.add('opacity-0','ease-out','duration-100')

    this.enabledIconTarget.classList.remove('opacity-0','ease-out','duration-100')
    this.enabledIconTarget.classList.add('opacity-100','ease-in','duration-200')
  }

  disable() {
    this.element.classList.remove(...this.enabledClasses)
    this.element.classList.add(...this.disabledClasses)

    this.iconsWrapperTarget.classList.remove('translate-x-5')
    this.iconsWrapperTarget.classList.add('translate-x-0')

    this.disabledIconTarget.classList.remove('opacity-0','ease-out','duration-100')
    this.disabledIconTarget.classList.add('opacity-100','ease-in','duration-200')

    this.enabledIconTarget.classList.remove('opacity-100','ease-in','duration-200')
    this.enabledIconTarget.classList.add('opacity-0','ease-out','duration-100')
  }

  update() {
    this.checkboxTarget.checked ? this.enable() : this.disable();
  }
}